import { KYCFile } from "@/core/services/api/interfaces/manager/KYCFile";
import { UserLead } from "@/core/services/api/interfaces/manager/UserLead";

export interface DocumentBunch {
  [index: string]: { [index: string]: string };
}

export enum ComplianceTrackingService {
  FILES = "files",
  FORM = "form",
  VIDEO = "video",
  FINAL = "final",
}

export enum CompliableType {
  TRANSACTION = "transaction",
  USER = "user",
  LEAD = "lead",
  COMPANY = "company",
}

export enum ComplianceTrackingStatus {
  DRAFT = "draft",
  OPEN = "open",
  VERIFIED = "verified",
  SUBMITTED = "submitted",
  DECLINED = "declined",
  NOT_FOUND = "not_found",
}

export enum ComplianceTrackingSubjectType {
  REGISTRATION = "REGISTRATION",
  TRANSACTION = "TRANSACTION",
  TRANSACTION_RECALL = "TRANSACTION_RECALL",
  AFFILIATE_TRANSFER = "AFFILIATE_TRANSFER",
  UNCATEGORIZED = "UNCATEGORIZED",
}

export interface FilterCompliances {
  status: ComplianceTrackingStatus[];
  service: ComplianceTrackingService[];
  compliable_type: CompliableType[];
  created_at: { from: string | null; to: string | null };
  page: number;
  per_page: number;
  order_by: { [index: string]: "asc" | "desc" };
}

export interface FilterCompliancesByCompanies extends FilterCompliances {
  company_id: number[];
}

export interface ComplianceTracking {
  id: number;
  name: string;
  subject_type: ComplianceTrackingSubjectType | null;
  description: null | string;
  service: ComplianceTrackingService | null;
  status?: ComplianceTrackingStatus;
  form_url?: string | null;
  video_url?: string | null;
  required_document_bunches?: DocumentBunch;
  required_files_bunches?: { [index: string]: KYCFile[] };
  files?: KYCFile[];
  compliable?:
    | CompliableTransaction
    | CompliableUser
    | UserLead
    | CompliableCompany
    | CompliableUserLead
    | null;
  compliable_type: null | CompliableType;
  compliable_id: null | number;
  compliable_entity_resource: {
    entity_type: string;
    entity_id: number;
  };
  tries_limit_exceeded: boolean;
}

export interface CompliableTransaction {
  id: number;
  bank_account_id: number;
  amount: string;
  currency: string;
  approved: boolean;
  status_id: string;
  readable_status: string;
  customer_full_name: null | string;
  customer_iban: null | string;
}

export interface CompliableUser {
  id: number;
  full_name: string;
  email: string;
  phone: null | string;
  first_name: string;
  last_name: string;
}

export interface CompliableCompany {
  id: number;
  name: string;
}

export interface CompliableUserLead {
  id: number;
  lead_number: string;
  user: CompliableUser;
  company: CompliableCompany;
  is_compliance_trackings_required: boolean;
}
